import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import cx from 'classnames';

import colorStyles from './style/color.css';
import fillStyles from './style/fill.css';
import generalStyles from './style/general.css';
import hoverStyles from './style/hover.css';
import positionStyles from './style/position.css';

const BUTTON_SIZE = 34;

export default function ToolbarButton({
  children,
  color,
  fill,
  hover,
  icon,
  isDisabled,
  isOpaque,
  isSlim,
  onClick,
  position,
}) {
  const buttonClasses = cx(
    colorStyles[color],
    fillStyles[fill],
    generalStyles.button,
    hoverStyles[hover],
    positionStyles[position],
    {
      [generalStyles.isDisabled]: isDisabled,
    }
  );

  const wrapClasses = cx({ [generalStyles.isOpaque]: isOpaque });

  const baseStyle = {
    height: BUTTON_SIZE,
    lineHeight: `${BUTTON_SIZE}px`,
  };

  const spacingStyle = !isSlim && {
    paddingLeft: icon ? BUTTON_SIZE : 10,
    paddingRight: children ? 10 : 0,
  };

  const buttonStyle = {
    ...baseStyle,
    ...spacingStyle,
  };

  const iconStyle = icon && { width: BUTTON_SIZE, height: BUTTON_SIZE };

  return (
    <div className={buttonClasses} style={buttonStyle} onClick={onClick}>
      <div className={wrapClasses}>
        {icon && (
          <div className={generalStyles.iconWrap} style={iconStyle}>
            <div className={generalStyles.icon}>{icon}</div>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

ToolbarButton.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf(Object.keys(colorStyles)),
  fill: PropTypes.oneOf(Object.keys(fillStyles)),
  hover: PropTypes.oneOf(Object.keys(hoverStyles)),
  icon: PropTypes.node,
  isDisabled: PropTypes.bool,
  isOpaque: PropTypes.bool,
  isSlim: PropTypes.bool,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(Object.keys(positionStyles)),
};

ToolbarButton.defaultProps = {
  color: 'slate',
  fill: 'smoke--xd',
  hover: 'background',
  icon: null,
  isDisabled: false,
  isOpaque: false,
  isSlim: false,
  onClick: noop,
  position: 'solo',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-toolbar/ToolbarButton/index.js